var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00009 6.78L1.68676 4.46667C1.42676 4.20667 1.00676 4.20667 0.746758 4.46667C0.486758 4.72667 0.486758 5.14667 0.746758 5.40667L3.53342 8.19334C3.79342 8.45334 4.21342 8.45334 4.47342 8.19334L11.5268 1.14C11.7868 0.880005 11.7868 0.460005 11.5268 0.200005C11.2668 -0.0599951 10.8468 -0.0599951 10.5868 0.200005L4.00009 6.78Z",
    fill: "#808495"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark.29851c8e9e6ef0c3d6c1e4efe3c1bb9e.svg";